import "./CardGenerator.css";

function loadFonts(targetWindow, deckData) {
  if (!deckData) {
    return;
  }
  for (let assetName in deckData.assets) {
    let asset = deckData.assets[assetName];
    if (asset.url?.includes(".ttf") || asset.url?.includes(".otf")) {
      let newFont = new FontFace(assetName, `url(${asset?.url})`);
      if (newFont.status !== "error") {
        newFont.load();
        targetWindow.document.fonts.add(newFont);
      }
    }
  }
}

export { loadFonts };
